import { Stack } from "@chakra-ui/react";
import React from "react";
import FormikControl from "../../Formik/index";

export const PantSizeForm = ({
  height,
  gudga,
  mandi,
  kambar,
  seat,
  bottom,
}) => {
  return (
    <Stack spacing="5">
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="उंची"
        type="number"
        name={height}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="कंबर"
        type="number"
        name={kambar}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="सीट"
        type="number"
        name={seat}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="मांडी"
        type="number"
        name={mandi}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="गुडगा"
        type="text"
        name={gudga}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="बॉटम"
        type="number"
        name={bottom}
      />
    </Stack>
  );
};
